import { IconProps } from "@/types/icons.ts";
import { useId } from "react";

export const CtaCardIcon = ({
  className,
  decorative = false,
  ariaLabel = "CTA card",
}: IconProps) => {
  const uniqueId = useId();
  const clip0Id = `clip0_${uniqueId}`;
  const clip1Id = `clip1_${uniqueId}`;
  const filterId = `filter0_d_${uniqueId}`;
  const mask1Id = `path-2-inside-1_${uniqueId}`;
  const mask2Id = `path-4-inside-2_${uniqueId}`;
  const effectId = `effect1_dropShadow_${uniqueId}`;

  return (
    <svg
      className={className}
      width="121"
      height="49"
      viewBox="0 0 121 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      <rect width="121" height="49" fill="#C5C7C9" />
      <g clipPath={`url(#${clip0Id})`}>
        <rect
          width="1440"
          height="35228"
          transform="translate(-608 -31452)"
          fill="white"
        />
        <rect
          width="1440"
          height="29722"
          transform="translate(-608 -29136)"
          fill="white"
        />
        <rect
          width="1055"
          height="29848.1"
          transform="translate(-223 -29136)"
          fill="white"
        />
        <rect
          width="900"
          height="29848.1"
          transform="translate(-223 -29136)"
          fill="white"
        />
        <g
          clipPath={`url(#${clip1Id})`}
          filter={`url(#${filterId})`}
        >
          <rect
            x="-199"
            y="-47.9004"
            width="320"
            height="96"
            rx="4"
            fill="#0066CC"
          />
          <mask id={mask1Id} fill="white">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M103.231 7.5H44.0314V44.1287L7.40001 44.1287L7.40001 103.329H44.0314V140.7H103.231V103.329H140.6V44.1287L103.231 44.1287V7.5Z"
            />
          </mask>
          <path
            d="M44.0314 7.5V3.5H40.0314V7.5H44.0314ZM103.231 7.5H107.231V3.5H103.231V7.5ZM44.0314 44.1287V48.1287H48.0314V44.1287H44.0314ZM7.40001 44.1287L7.40001 40.1287H3.40001L3.40001 44.1287H7.40001ZM7.40001 103.329H3.40001V107.329H7.40001V103.329ZM44.0314 103.329H48.0314V99.3287H44.0314V103.329ZM44.0314 140.7H40.0314V144.7H44.0314V140.7ZM103.231 140.7V144.7H107.231V140.7H103.231ZM103.231 103.329V99.3287H99.2314V103.329H103.231ZM140.6 103.329V107.329H144.6V103.329H140.6ZM140.6 44.1287H144.6V40.1287H140.6V44.1287ZM103.231 44.1287H99.2314V48.1287H103.231V44.1287ZM44.0314 11.5H103.231V3.5H44.0314V11.5ZM48.0314 44.1287V7.5H40.0314V44.1287H48.0314ZM7.40001 48.1287L44.0314 48.1287V40.1287L7.40001 40.1287L7.40001 48.1287ZM11.4 103.329L11.4 44.1287H3.40001L3.40001 103.329H11.4ZM44.0314 99.3287H7.40001V107.329H44.0314V99.3287ZM48.0314 140.7V103.329H40.0314V140.7H48.0314ZM103.231 136.7H44.0314V144.7H103.231V136.7ZM99.2314 103.329V140.7H107.231V103.329H99.2314ZM140.6 99.3287H103.231V107.329H140.6V99.3287ZM136.6 44.1287V103.329H144.6V44.1287H136.6ZM103.231 48.1287L140.6 48.1287V40.1287L103.231 40.1287V48.1287ZM99.2314 7.5V44.1287H107.231V7.5H99.2314Z"
            fill="white"
            mask={`url(#${mask1Id})`}
          />
          <g opacity="0.4">
            <mask id={mask2Id} fill="white">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M75.363 6.85156H53.363V20.4641L39.75 20.4641V42.4641H53.363V56.3516H75.363V42.4641H89.25V20.4641L75.363 20.4641V6.85156Z"
              />
            </mask>
            <path
              d="M53.363 6.85156V3.85156H50.363V6.85156H53.363ZM75.363 6.85156H78.363V3.85156H75.363V6.85156ZM53.363 20.4641V23.4641H56.363V20.4641H53.363ZM39.75 20.4641L39.75 17.4641H36.75V20.4641H39.75ZM39.75 42.4641H36.75V45.4641H39.75V42.4641ZM53.363 42.4641H56.363V39.4641H53.363V42.4641ZM53.363 56.3516H50.363V59.3516H53.363V56.3516ZM75.363 56.3516V59.3516H78.363V56.3516H75.363ZM75.363 42.4641V39.4641H72.363V42.4641H75.363ZM89.25 42.4641V45.4641H92.25V42.4641H89.25ZM89.25 20.4641H92.25V17.4641H89.25V20.4641ZM75.363 20.4641H72.363V23.4641H75.363V20.4641ZM53.363 9.85156H75.363V3.85156H53.363V9.85156ZM56.363 20.4641V6.85156H50.363V20.4641H56.363ZM39.75 23.4641L53.363 23.4641V17.4641L39.75 17.4641L39.75 23.4641ZM42.75 42.4641V20.4641H36.75V42.4641H42.75ZM53.363 39.4641H39.75V45.4641H53.363V39.4641ZM56.363 56.3516V42.4641H50.363V56.3516H56.363ZM75.363 53.3516H53.363V59.3516H75.363V53.3516ZM72.363 42.4641V56.3516H78.363V42.4641H72.363ZM89.25 39.4641H75.363V45.4641H89.25V39.4641ZM86.25 20.4641V42.4641H92.25V20.4641H86.25ZM75.363 23.4641H89.25V17.4641L75.363 17.4641V23.4641ZM72.363 6.85156V20.4641H78.363V6.85156H72.363Z"
              fill="white"
              mask={`url(#${mask2Id})`}
            />
          </g>
        </g>
      </g>
      <defs>
        <filter
          id={filterId}
          x="-215"
          y="-63.9004"
          width="352"
          height="128"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="8" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result={effectId}
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2={effectId}
            result="shape"
          />
        </filter>
        <clipPath id={clip0Id}>
          <rect
            width="1440"
            height="35228"
            fill="white"
            transform="translate(-608 -31452)"
          />
        </clipPath>
        <clipPath id={clip1Id}>
          <rect
            width="320"
            height="96"
            fill="white"
            transform="translate(-199 -47.9004)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};


